export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
export const LOG_OUT = "LOG_OUT";
